import type { FC } from "react";
import * as utils from "app/components/filters-bar/utils";
import { CountryFilter as CountryFilterSelector } from "app/components/filters-bar/country-filter/CountryFilter";
import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import type { ICountryObject } from "app/services/CountryService";
import { i18nFilter } from "app/filters/i18nFilter";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { InfoTooltip } from "app/components/React/Tooltip/InfoTooltip/InfoTooltip";
import { allTrackers } from "app/services/track/track";

interface ICountryDropdown {
    selectedCountry: ICountryObject;
    onChangeSelectedCountry: (country: ICountryObject) => void;
}

const { carbon } = colorsPalettes;

const CountriesAutocompleteContainer = styled.div`
    height: 40px;
    width: 100%;
    border: 1px ${carbon[50]} solid;
    border-radius: 3px;
    background: white;
    .CountryFilter-dropdownButton {
        ${setFontVariant("input2")};
    }

    .DropdownButton--filtersBarDropdownButton {
        border-left: none;
    }
`;

const Container = styled(FlexRow)`
    gap: 8px;
    width: 100%;
    align-items: center;
    margin: 16px 0px;
`;

export const CountryDropdown: FC<ICountryDropdown> = (props) => {
    const availableCountries = utils.getCountries();
    const { selectedCountry = availableCountries[0], onChangeSelectedCountry } = props;
    const i18n = i18nFilter();
    const changeCountry = (country) => {
        onChangeSelectedCountry(country);
        allTrackers.trackEvent("Pop up", "Click", `Edit Category/changeCountry/${country.text}`);
    };
    return (
        <Container>
            <CountriesAutocompleteContainer>
                <CountryFilterSelector
                    width={"100%"}
                    height={40}
                    dropdownPopupWidth={418}
                    availableCountries={availableCountries}
                    selectedCountryIds={{ [selectedCountry.id]: true }}
                    changeCountry={changeCountry}
                    dropdownPopupHeight={230}
                    cssClassContainer={"market-builder-filter"}
                />
            </CountriesAutocompleteContainer>
            <InfoTooltip infoText={i18n("industry.research.edit.modal.country.tooltip")} />
        </Container>
    );
};
